import axios from 'axios'
import constant from "@/constant";

const reissuance_request_form = {
  namespaced: true,

  state() {
    return {
      data: {
        id: null,
        status_text: null,
        request_at: null,
        issue_documents: [],
        billing_price: 0,
        building: {
          name: null,
          name_kana: null,
          postal_code: null,
          address: null,
          address2: null,
          management_company_id: null,
        },
        building_house_number: null,
        owner_name: null,
        note: null,
        contact: null,
        reissue_reason: null,
        payment_method: null,
      },
      errors: {},
    };
  },

  getters: {
    issueDocumentName(state) {
      return state.data.issue_documents.map(issueDocument => issueDocument.name).join('、');
    },
    reissueParameter(state) {
      return {
        reissue_reason: state.data.reissue_reason,
        payment_method: state.data.payment_method,
        management_company_id: state.data.building.management_company_id
      };
    }
  },

  mutations: {
    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
    setErrors(state, errors) {
      state.errors = { ...errors };
    },
    setError(state, payload) {
      state.errors[payload.key] = payload.value;
    },
    resetErrors(state) {
      state.errors = {};
    },
    setData(state, data) {
      state.data.id = data.id;
      state.data.status_text = data.status_text;
      state.data.request_at = data.request_at;
      state.data.issue_documents = data.issue_documents;
      state.data.billing_price = data.billing_price;
      state.data.building.name = data.building.name;
      state.data.building.name_kana = data.building.name_kana;
      state.data.building.postal_code = data.building.postal_code;
      state.data.building.address = data.building.address;
      state.data.building.address2 = data.building.address2;
      state.data.building.management_company_id = data.building.management_company_id;
      state.data.building_house_number = data.building_house_number;
      state.data.owner_name = data.owner_name;
      state.data.note = data.note;
      state.data.contact = data.contact;
      state.data.reissue_reason = data.reissue_reason;
      state.data.payment_method = data.payment_method;
      state.errors = {};
    },
    resetData(state) {
      state.data.id = null;
      state.data.status_text = null;
      state.data.request_at = null;
      state.data.issue_documents = [];
      state.data.billing_price = 0;
      state.data.building.name = null;
      state.data.building.name_kana = null;
      state.data.building.postal_code = null;
      state.data.building.address = null;
      state.data.building.address2 = null;
      state.data.building.management_company_id = null;
      state.data.building_house_number = null;
      state.data.owner_name = null;
      state.data.note = null;
      state.data.contact = null;
      state.data.reissue_reason = null;
      state.data.payment_method = null;
      state.errors = {};
    },
  },

  actions: {
    load({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/api/issuance_requests/' + payload.id).then((response) => {
          if (![constant.ISSUANCE_REQUEST_STATUS.ISSUANCE_COMPLETED.code, constant.ISSUANCE_REQUEST_STATUS.DOWNLOAD_COMPLETED.code].includes(response.data.data.status)) {
            return reject({ conflict: true });
          }
          commit('setData', response.data.data);
          resolve(true);
        }).catch(() => reject());
      });
    },
    validate({ state, commit }) {
      commit('resetErrors');
      return new Promise((resolve, reject) => {
        if (!state.data.reissue_reason) {
          commit('setError', { key: 'reissue_reason', value: ['再発行理由の入力は必須です。'] });
        } else if (state.data.reissue_reason.length > 5000) {
          commit('setError', { key: 'reissue_reason', value: ['再発行理由は、5000文字以下で指定してください。'] });
        }

        if (Object.keys(state.errors).length === 0) {
          resolve(true);
        } else {
          reject(state.errors);
        }
      });
    },
    register({ state, getters, commit }) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/issuance_requests/${state.data.id}/reissue`, getters.reissueParameter).then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({ handled });
        })
      });
    },
  },
};

export default reissuance_request_form;
